import React from 'react';
import './ChatBubble.css';
import ReactMarkdown from 'react-markdown';

interface ChatBubbleProps {
    role: string;
    message: string;
    children?: any;
}

const ChatBubble: React.FC<ChatBubbleProps> = ({ role, message }) => {
    const bubbleClass = role === 'assistant' ? 'assistant-bubble' : 'user-bubble';

    return (
        <div className={'chat-bubble-wrapper'}>
            <div className={`chat-bubble ${bubbleClass}`}>
                {role === 'assistant' &&
                    <ReactMarkdown
                        children={message ?? ''}
                        // components={{
                        //     code({className, children}) {
                        //         return(
                        //             <code className={className}>
                        //                 {children}
                        //             </code>
                        //         )
                        //     }
                        // }}
                    />
                }
                {role === 'user' && message}
            </div>
        </div>
    );
};

export default ChatBubble;